import React, { useRef, useEffect, useState, useCallback } from "react";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CssBaseline from "@mui/material/CssBaseline";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { alpha } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import FaceIcon from "@mui/icons-material/Face";
import DoneIcon from "@mui/icons-material/Done";
import LinearProgress from "@mui/material/LinearProgress";

import SalesOrderProducts from "./SalesOrderProducts";
import SalesOrderProductsReview from "./SalesOrderProductsReview";
import InvoiceInformationReview from "./InvoiceInformationReview";
import axios from "axios";
import { format, parseISO } from "date-fns";
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";

const drawerWidth = 300;

const materialTheme = createTheme({
  // set default for now
  palette: {
    primary: {
      main: "#40A414",
    },
  },
});

const useStyles = makeStyles((theme) => ({
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
    roota: {
      ...theme.typography.button,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(1),
    },
  },
}));

const filter = createFilterOptions();

function ManageInventoryPurchaseOrder(props) {
  const classes = useStyles();
  const [autoSuggestProducts, setAutoSuggestProducts] = useState(null);
  const [salesOrders, setSalesOrders] = useState([]);
  const [openSaleOrderProductDialog, setOpenSaleOrderProductDialog] = useState(false);
  const [openSaleOrderProductReviewDialog, setOpenSaleOrderProductReviewDialog] = useState(false);
  const [openInvoiceInformationReviewDialog, setOpenInvoiceInformationReviewDialog] =
    useState(false);
  const [selectedSalesOrder, setSelectedSalesOrder] = useState();
  const [reviewedSalesOrderItems, setReviewedSalesOrderItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasMorePurchaseOrderToLoad, setHasPurchaseOrderToLoad] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [loadPurchaseOrders, setLoadPurchaseOrders] = useState(true);

  const lastProductElementObserver = useRef();
  const lastProductElement = useCallback(
    (node) => {
      // if(isLoading){
      //     return
      // }
      if (lastProductElementObserver.current) {
        lastProductElementObserver.current.disconnect();
      }
      lastProductElementObserver.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMorePurchaseOrderToLoad) {
          lastProductElementObserver.current.disconnect();
          console.log("visible");
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
          setLoadPurchaseOrders(true);
        }
      });

      if (node) {
        lastProductElementObserver.current.observe(node);
      }
    },
    [isLoading]
  );

  function search() {
    return (
      <div
        position="static"
        style={{ border: ".1rem solid #989898", borderRadius: "4px", margin: "2px" }}
      >
        <Toolbar variant="dense" style={{ padding: "0" }}>
          <Box flexGrow={1}>{autoComplete}</Box>
          <Box>
            <IconButton className={classes.margin} size="large">
              <SearchIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </div>
    );
  }
  function openSaleOrderProductReviewDialogWithReviewedItems(reviewedSalesOrderItems) {
    setReviewedSalesOrderItems(reviewedSalesOrderItems);
    setOpenSaleOrderProductReviewDialog(true);
  }

  function openInvoiceInformationReviewDialogWithReviewedItems(reviewedSalesOrderItems) {
    setReviewedSalesOrderItems(reviewedSalesOrderItems);
    setOpenInvoiceInformationReviewDialog(true);
  }

  function autoComplete() {
    return (
      <Autocomplete
        value={autoSuggestProducts}
        noOptionsText={"No record found"}
        onChange={(event, newValue) => {
          if (typeof newValue === "string") {
            setAutoSuggestProducts({
              name: newValue,
            });
          } else if (newValue && newValue.inputValue) {
            // Create a new value from the user input
            setAutoSuggestProducts({
              name: newValue.inputValue,
            });
          } else {
            setAutoSuggestProducts(newValue);
          }
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        options={salesOrders}
        getOptionLabel={(option) => {
          // Value selected with enter, right from the input
          if (typeof option === "string") {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.inputValue;
          }
          // Regular option
          return option.name;
        }}
        renderOption={(option) => option.name}
        style={{ width: "100%", paddingLeft: "8px" }}
        renderInput={(params) => (
          <TextField {...params} InputProps={{ ...params.InputProps, disableUnderline: true }} />
        )}
      />
    );
  }

  function salesOrderOnClick(salesOrder) {
    setSelectedSalesOrder(salesOrder);

    setOpenSaleOrderProductDialog(true);
  }
  function salesOrderSuccessfullyReceived(selectedSalesOrder) {
    setOpenSaleOrderProductDialog(false);
    setOpenSaleOrderProductReviewDialog(false);
    setOpenInvoiceInformationReviewDialog(false);
  }
  function closeAllDialog() {
    setOpenSaleOrderProductDialog(false);
    setOpenSaleOrderProductReviewDialog(false);
    setOpenInvoiceInformationReviewDialog(false);
  }

  function formatDate(dateString) {
    try {
      return format(parseISO(dateString), "MMMM d,yyyy");
    } catch (err) {
      return "";
    }
  }
  function formatAmount(amount) {
    return Number(amount).toLocaleString("en-US", { maximumFractionDigits: 2 });
  }

  function salesOrderItem(salesOrder) {
    return (
      <Grid
        container
        spacing={2}
        onClick={() => {
          salesOrderOnClick(salesOrder);
        }}
      >
        <Grid item xs={12} sm container>
          <Grid item xs container direction="column" spacing={2}>
            <Grid item xs>
              <Typography gutterBottom variant="subtitle1">
                Purchase Order: {salesOrder.sales_order_number}
                <br />
                Seller: {salesOrder.seller_name}
                <br />
                Purchase Order Quantity: {salesOrder.number_of_items} Units
                <br />
                Purchase Order Value: {formatAmount(salesOrder.grand_total)}
                <br />
                Purchase Order Date: {formatDate(salesOrder.created)}
                <br />
                Requested Delivery Date: {formatDate(salesOrder.requested_delivery_date)}
                <br />
              </Typography>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                  {salesOrder.seller_received_sale_order_informations != null ? (
                    <Chip icon={<DoneIcon />} label="Received" color="primary" variant="outlined" />
                  ) : (
                    <Chip label="Pending" variant="outlined" />
                  )}
                </ThemeProvider>
              </StyledEngineProvider>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
  function generatePurchaseOrder() {
    return (
      <List>
        {salesOrders.map((salesOrder, index) =>
          salesOrders.length === index + 1 ? (
            <ListItem ref={lastProductElement} button divider key={salesOrder.id + index}>
              {salesOrderItem(salesOrder)}
            </ListItem>
          ) : (
            <ListItem button divider key={salesOrder.id + index}>
              {salesOrderItem(salesOrder)}
            </ListItem>
          )
        )}
      </List>
    );
  }

  function generateSampleSalesOrder() {
    var salesOrders = [];

    var salesOrder = {};
    salesOrder.id = new Date().getTime() + Math.floor(Math.random() * 100);
    salesOrder.sales_order_number = "300201";
    salesOrder.seller_name = "Don Hermanos";
    salesOrder.number_of_items = 6;
    salesOrder.grand_total = "345.00";
    salesOrder.requested_delivery_date = "2021-10-08T00:00:00+00:00";
    salesOrder.created = "2021-10-08T00:00:00+00:00";
    salesOrders.push(salesOrder);

    return salesOrders;
  }

  const objectToFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);

      return formData;
    }, new FormData());

  useEffect(() => {
    if (!loadPurchaseOrders) {
      return;
    }
    setIsLoading(true);

    const options = {
      method: "POST",
      url: "/Orders/getSalesOrders.json",
      data: objectToFormData({ page_number: pageNumber }),
    };
    axios(options)
      .then((res) => {
        setIsLoading(false);
        setLoadPurchaseOrders(false);

        const isSuccess = res.data.response.is_success;

        setHasPurchaseOrderToLoad(res.data.response.sales_orders.length > 0);

        if (!isSuccess) {
          alert("Error encounter");

          // setIsSavingSuccess(false)
          // setIsSavingAccount(false)
          // setMessageDialogMessage(res.data.response.message)
          // setShowMessageDialog(true)

          return;
        }

        setSalesOrders(salesOrders.concat(res.data.response.sales_orders));

        // setIsSavingSuccess(true)
        // setIsSavingAccount(false)
        // setMessageDialogMessage("Account save successfully.")
        // setShowMessageDialog(true)
      })
      .catch((error) => {
        setIsLoading(false);

        // setIsSavingSuccess(false)
        alert("Error encounter");
        console.log(error);
      });
  }, [loadPurchaseOrders]);

  return (
    <div>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={props.handleDrawerToggle}
            className={classes.menuButton}
            size="large"
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="subtitle1" noWrap>
            Transacti Receive Products
          </Typography>
        </Toolbar>
      </AppBar>
      {/* {search()} */}
      {generatePurchaseOrder()}
      {
        <SalesOrderProducts
          openSaleOrderProductReviewDialogWithReviewedItems={
            openSaleOrderProductReviewDialogWithReviewedItems
          }
          selectedSalesOrder={selectedSalesOrder}
          openSaleOrderProductDialog={openSaleOrderProductDialog}
          setOpenSaleOrderProductDialog={setOpenSaleOrderProductDialog}
          setOpenSaleOrderProductReviewDialog={setOpenSaleOrderProductReviewDialog}
        />
      }
      {
        <SalesOrderProductsReview
          openInvoiceInformationReviewDialogWithReviewedItems={
            openInvoiceInformationReviewDialogWithReviewedItems
          }
          reviewedSalesOrderItems={reviewedSalesOrderItems}
          selectedSalesOrder={selectedSalesOrder}
          openSaleOrderProductReviewDialog={openSaleOrderProductReviewDialog}
          setOpenSaleOrderProductReviewDialog={setOpenSaleOrderProductReviewDialog}
          setOpenInvoiceInformationReviewDialog={setOpenInvoiceInformationReviewDialog}
        />
      }
      {
        <InvoiceInformationReview
          reviewedSalesOrderItems={reviewedSalesOrderItems}
          selectedSalesOrder={selectedSalesOrder}
          openInvoiceInformationReviewDialog={openInvoiceInformationReviewDialog}
          setOpenInvoiceInformationReviewDialog={setOpenInvoiceInformationReviewDialog}
          salesOrderSuccessfullyReceived={salesOrderSuccessfullyReceived}
        />
      }
      {isLoading ? (
        <LinearProgress
          color="secondary"
          style={{ marginLeft: ".1rem", marginRight: ".1rem", marginBottom: ".5rem" }}
        />
      ) : (
        ""
      )}
    </div>
  );
}

export default ManageInventoryPurchaseOrder;
